import { useQuery } from '@tanstack/react-query'
import { themesApi } from '@api/endpoints/themes'
import type { ThemeDto } from '@api/types/theme'

export const themeKeys = {
  all: ['themes'] as const,
  myThemes: () => [...themeKeys.all, 'my-themes'] as const,
  detail: (slug: string) => [...themeKeys.all, 'detail', slug] as const,
}

/** Fetch the current user's unlocked themes */
export function useMyThemes() {
  return useQuery<ThemeDto[]>({
    queryKey: themeKeys.myThemes(),
    queryFn: async () => {
      const response = await themesApi.getMyThemes()
      return response.themes
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
